var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3747 1.55811H7.13715C3.86931 1.55811 1.22021 4.67336 1.22021 8.51622V39.3706C1.22021 43.2135 3.86931 46.3288 7.13715 46.3288H33.3747C36.6426 46.3288 39.2917 43.2135 39.2917 39.3706V8.51622C39.2917 4.67336 36.6426 1.55811 33.3747 1.55811Z",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7217 19.1814C24.5314 17.1854 23.7858 15.2454 22.485 13.7157C19.4314 10.1247 14.4741 10.1247 11.4205 13.7157C8.36684 17.3067 8.36684 23.1362 11.4205 26.7272C14.4741 30.3181 19.4314 30.3181 22.485 26.7272C23.3853 25.6685 24.0158 24.4093 24.3846 23.0756",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0684 29.3576C16.2587 31.3536 17.0043 33.2937 18.305 34.8234C21.3587 38.4143 26.3159 38.4143 29.3696 34.8234C32.4232 31.2324 32.4232 25.4029 29.3696 21.8119C26.3159 18.2209 21.3587 18.2209 18.305 21.8119C17.4048 22.8705 16.7743 24.1297 16.4054 25.4635",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.5349a1af1a0db67749479de87e46a30c.svg";
export { ForwardRef as ReactComponent };